/**
 * naturaAzienda — che cosa è un'azienda per i conti della piattaforma (02/11/2026). Pura, senza dipendenze: la leggono la
 * regola degli strumenti (`strumenti/attivazione.ts`), il canone (`canoneMensile.ts`), la console e il server.
 *
 * `dimostrativa` solo se lo dice `billing.natura`, mai dedotto da altro (una prova lunghissima, un'esenzione, un nome con
 * «Demo»). Assente o sconosciuto = `cliente`. Il campo sta in `billing`, che le regole lasciano scrivere solo al server e
 * al super utente: un'azienda non può dichiararsi dimostrativa da sola. Perché esiste: `NaturaAzienda` in
 * `types/tenant.types.ts`.
 */
import type { NaturaAzienda } from '../types/tenant.types';

/** PURA. */
export function naturaDellAzienda(datiAzienda: unknown): NaturaAzienda {
  const d = typeof datiAzienda === 'object' && datiAzienda !== null ? (datiAzienda as Record<string, unknown>) : {};
  const b = typeof d.billing === 'object' && d.billing !== null ? (d.billing as Record<string, unknown>) : {};
  return b.natura === 'dimostrativa' ? 'dimostrativa' : 'cliente';
}
